export default "__VITE_ASSET__BzndGrWR__"